import { HandHoldingDollarSolidV6 } from "@shared/v2/Icomoon";

import ActivityContainer from "./ActivityContainer";
import { activityCommonDefaultProps, activityCommonPropTypes, STYLES } from "../common";
import Header from "./Header";
import CategoryContainer from "./CategoryContainer";
import { noNamer } from "../../../../Contacts/ModalViews/helpers";
import DataField from "./DataField";

const LoanStatusUpdatedActivity = ({ activity, onReadChange }) => {
  return (
    <ActivityContainer activity={activity} onReadChange={onReadChange}>
      <Header
        category={
          <CategoryContainer
            containerClassName="tw-bg-[#FAF1E6] tw-text-[#AD6714]"
            Icon={HandHoldingDollarSolidV6}
          >
            Loan Status Updated
          </CategoryContainer>
        }
        personName={noNamer(activity.data?.subjectFirstName, activity.data?.subjectLastName)}
        time={activity.createdAt}
        onReadChange={onReadChange}
        loading={activity.loading}
        read={activity.read}
      />
      <div className={`${STYLES.contentContainer} tw-text-14d`}>
        <span className={STYLES.lineClamp3}>
          Loan Status updated from <b className="tw-uppercase">{activity.data?.previousStatus || "N/A"}</b> to{" "}
          <b className="tw-uppercase">{activity.data?.newStatus || "N/A"}</b>
        </span>
        {activity.data?.transactionName && (
          <DataField label="Transaction" data={activity.data?.transactionName} />
        )}
      </div>
    </ActivityContainer>
  );
};

export default LoanStatusUpdatedActivity;

LoanStatusUpdatedActivity.propTypes = {
  ...activityCommonPropTypes,
};

LoanStatusUpdatedActivity.defaultProps = {
  ...activityCommonDefaultProps,
};
